import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebaseの設定
const firebaseConfig = {
  apiKey: "AIzaSyAjrKmJwfpzFSFo6l-9zVMeSUkX53rC8Mo",
  authDomain: "miyazaki-quiz-agriculture.firebaseapp.com",
  projectId: "miyazaki-quiz-agriculture",
  storageBucket: "miyazaki-quiz-agriculture.firebasestorage.app",
  messagingSenderId: "726853191109",
  appId: "1:726853191109:web:0ed8d652a2bb01af81f7ac"
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// Firestoreのインスタンスを取得
export const db = getFirestore(app);
